import Button from '@mui/material/Button';
import styled from 'styled-components';

interface StyledButtonProps {
  variant: 'text' | 'contained' | 'outlined';
  size?: 'small' | 'medium' | 'large';
  width?: string;
}

export const StyledButton = styled(Button)<StyledButtonProps>`
  background: ${({ variant, theme }) =>
    variant !== 'text' && variant === 'contained'
      ? `${theme.colors.primary}`
      : 'transparent'}!important;
  border: ${({ variant, theme }) =>
    variant !== 'text' && variant === 'contained'
      ? '1px'
      : `1px solid ${theme.colors.primary}`}!important;
  color: ${({ variant, theme }) =>
    variant !== 'text' && variant === 'contained'
      ? theme.colors.background_white
      : `1px solid ${theme.colors.primary}`}!important;

  width: ${({ size, width }) =>
    width === undefined
      ? size !== 'small' && size === 'large'
        ? '12rem'
        : '12rem'
      : width}!important;
  height: ${({ size }) => (size !== 'small' && size === 'large' ? '2.5rem' : '2rem')}!important;
  border-radius: ${({ size }) =>
    size !== 'small' && size === 'large' ? '2rem' : '1.6rem'}!important;

  font-size: 13px !important;

  &:hover {
    transition: 0.5s;
    color: ${({ variant, theme }) =>
      variant !== 'text' && variant === 'contained'
        ? theme.colors.background_white
        : theme.colors.background_white}!important;
    background: ${({ variant, theme }) =>
      variant !== 'text' && variant === 'outlined'
        ? `${theme.colors.primary}`
        : `${theme.colors.secondary}`}!important;
  }

  &:focus {
    border: ${({ variant, theme }) =>
      variant !== 'text' && variant === 'contained'
        ? '1px'
        : `1px solid ${theme.colors.secondary}`}!important;
  }

  &:disabled:hover {
    cursor: not-allowed;
    color: ${({ variant, theme }) =>
      variant !== 'text' && variant === 'contained'
        ? theme.colors.background_white
        : `${theme.colors.primary}`}!important;
    background: ${({ variant, theme }) =>
      variant !== 'text' && variant === 'contained'
        ? `${theme.colors.primary}`
        : 'transparent'}!important;
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
